import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

type ExcelProps = IconComponentBaseProps;

export const Excel = ({ className, width = 24, height = 25 }: ExcelProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4998 12.5003L9.96026 11.2833L5.99951 12.5003V20.4174C5.99951 20.6383 6.08729 20.8503 6.24354 21.0065C6.39978 21.1627 6.6117 21.2505 6.83266 21.2505H20.1668C20.3878 21.2505 20.5997 21.1627 20.756 21.0065C20.9122 20.8503 21 20.6383 21 20.4174V16.8754L13.4998 12.5003Z"
        fill="#185C37"
      />
      <path
        d="M13.4998 3.75H6.83266C6.6117 3.75 6.39978 3.83778 6.24354 3.99402C6.08729 4.15027 5.99951 4.36219 5.99951 4.58315V8.12513L13.4998 12.5003L17.2499 14.0828L21 12.5003V8.12513L13.4998 3.75Z"
        fill="#21A366"
      />
      <path d="M13.4998 8.12512H5.99951V12.5003H13.4998V8.12512Z" fill="#107C41" />
      <path
        d="M20.1668 3.75H13.4997V8.12513H20.9999V4.58315C20.9999 4.36219 20.9121 4.15027 20.7559 3.99402C20.5997 3.83778 20.3877 3.75 20.1668 3.75Z"
        fill="#33C481"
      />
      <path d="M20.9999 12.5002H13.4997V16.8753H20.9999V12.5002Z" fill="#107C41" />
      <path
        opacity="0.1"
        d="M11.4166 6.87512H5.99951V18.7505H11.4166C11.6373 18.7498 11.8489 18.6618 12.005 18.5057C12.1611 18.3496 12.2491 18.1381 12.2497 17.9173V7.70827C12.2491 7.48751 12.1611 7.27597 12.005 7.11987C11.8489 6.96377 11.6373 6.87578 11.4166 6.87512Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M10.7915 7.50012H5.99951V19.3755H10.7915C11.0123 19.3748 11.2239 19.2868 11.38 19.1307C11.5361 18.9746 11.6241 18.7631 11.6247 18.5423V8.33327C11.6241 8.11251 11.5361 7.90098 11.38 7.74487C11.2239 7.58877 11.0123 7.50078 10.7915 7.50012Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M10.7915 7.50012H5.99951V18.1254H10.7915C11.0123 18.1248 11.2239 18.0368 11.38 17.8807C11.5361 17.7246 11.6241 17.513 11.6247 17.2923V8.33327C11.6241 8.11251 11.5361 7.90098 11.38 7.74487C11.2239 7.58877 11.0123 7.50078 10.7915 7.50012Z"
        fill="black"
      />
      <path
        opacity="0.2"
        d="M10.1665 7.50012H5.99951V18.1254H10.1665C10.3873 18.1248 10.5988 18.0368 10.7549 17.8807C10.911 17.7246 10.999 17.513 10.9997 17.2923V8.33327C10.999 8.11251 10.911 7.90098 10.7549 7.74487C10.5988 7.58877 10.3873 7.50078 10.1665 7.50012Z"
        fill="black"
      />
      <path
        d="M10.1665 7.50012H1.83315C1.37301 7.50012 1 7.87314 1 8.33327V16.6666C1 17.1268 1.37301 17.4998 1.83315 17.4998H10.1665C10.6267 17.4998 10.9997 17.1268 10.9997 16.6666V8.33327C10.9997 7.87314 10.6267 7.50012 10.1665 7.50012Z"
        fill="#107C41"
      />
      <path
        d="M3.28577 15.6254L5.24958 12.579L3.4514 9.55017H4.90019L5.88335 11.4877C5.97335 11.6715 6.03586 11.8084 6.07086 11.899H6.08336C6.14836 11.7523 6.21628 11.6096 6.28711 11.4709L7.33777 9.55205H8.66781L6.81963 12.5628L8.71344 15.6254H7.29839L6.16273 13.5003C6.10921 13.4099 6.06382 13.315 6.02711 13.2165H6.01023C5.97689 13.313 5.93286 13.4055 5.87897 13.4922L4.70957 15.6254H3.28577Z"
        fill="white"
      />
    </svg>
  );
};
